import styled from 'styled-components';
import { rem } from 'polished';
import Text from '@atoms/Text/Text';
import Button from '@atoms/Button/Button';

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: ${rem(180)};
`;

export const StyledInfo = styled(Text)`
  && {
    margin-bottom: ${rem(10)};
  }
`;

export const StyledButton = styled(Button)`
  && {
    min-width: ${rem(112)};
    margin-top: ${rem(16)};
  }
`;
